module.exports = __webpack_public_path__ + "media/site/images/home_case_studies/home-case-study-ekanban-tablet@2x-828786ff9a0b863cf8c70c95956eaef0.png";